import {Button, Input, Row, Table} from "antd";
import React, {useMemo, useState} from "react";
import {CallbackListItem} from "./CallbackListItem";

export const CallbackEdit = ({callback, setCallback}) => {
    const handleChange = (id, field, value) => {
        callback[id][field] = value;
        setCallback(callback);
    };

    return (
        <div>
            <div style={{
                display: "flex",
                justifyContent: "flex-end"
            }} >
                <Button type={"primary"} onClick={() => setCallback([...callback, {key: "", value: ""}])}>
                    Yeni Satır
                </Button>
            </div>
            {callback.map(({key, value}, index) => (
                <CallbackListItem
                    defaultKey={key}
                    value={value}
                    key={index}
                    setKey={value => handleChange(index, "key", value)}
                    setValue={value => handleChange(index, "value", value)}
                />
            ))}
        </div>
    );
};
